<script>
export default {
  name: "google-map",
  props: {
    name: {
      type: String,
      required: true
    },
    lat: {
      type: Number,
      required: false,
      default: -31.7541237
    },
    lng: {
      type: Number,
      required: false,
      default: -52.317566899999974
    },
    withAutocomplete: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data: function() {
    return {
      mapName: this.name + "-map",
      acName: this.name + "-ac",
      map: null,
      ac: null,
      marker: null,
      geocoder: new google.maps.Geocoder(),
      point: new google.maps.LatLng(this.lat, this.lng)
    };
  },

  methods: {
    createMap() {
      var element = document.getElementById(this.mapName);
      var options = {
        zoom: 17,
        center: this.point,
        disableDefaultUI: true
      };

      this.map = new google.maps.Map(element, options);
    },

    createAutocomplete() {
      var element = document.getElementById(this.acName);
      var options = {
        types: ["address"]
      };

      this.ac = new google.maps.places.Autocomplete(element, options);
    },

    createMarker() {
      var options = {
        map: this.map,
        position: this.point,
        draggable: this.withAutocomplete
      };
      this.marker = new google.maps.Marker(options);
    },

    creating() {
      this.createMap();
      this.createMarker();

      //If you just want to show the map stop here
      if (!this.withAutocomplete) return;

      this.createAutocomplete();

      //Define 'this' on variable for use this in google scopes
      var t = this;

      google.maps.event.addListener(t.ac, "place_changed", function() {
        var place = t.ac.getPlace();
        t.update(place.geometry.location);
        t.getPlaceComponents(place);
      });

      google.maps.event.addListener(t.marker, "dragend", function() {
        var position = t.marker.getPosition();
        t.update(position);

        t.geocoder.geocode({ latLng: position }, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK && results[0]) {
            var place = results[0];
            t.getPlaceComponents(place);
          }
        });
      });
    },

    update(position) {
      this.point = new google.maps.LatLng(position.lat(), position.lng());
      this.map.panTo(this.point);
      this.marker.setPosition(this.point);
    },

    getPlaceComponents(place) {
      let components = place.address_components;
      let location = place.geometry.location;

      let data = {
        street_number: this.extractAddress(components, "street_number"),
        street: this.extractAddress(components, "route"),
        district: this.extractAddress(components, "sublocality_level_1"),
        city:
          this.extractAddress(components, "administrative_area_level_2") ||
          this.extractAddress(components, "locality"),
        zip_code: this.extractAddress(components, "postal_code"),
        lonlat: `POINT(${location.lng()} ${location.lat()})`
      };

      if (!data.street || !data.street_number || !data.city) {
        this.$emit("placeIncompleted");
        return;
      }

      this.$emit("placeChanged", data);
    },

    extractAddress(components, type) {
      var ret = false;

      components.forEach(component => {
        component.types.forEach(el => {
          if (el === type) ret = component.long_name;
        });
      });

      return ret;
    }
  },

  mounted() {
    this.creating();
  }
};
</script>

<template>
  <section class="mt-10">
    <form v-if="withAutocomplete" @submit.prevent autocomplete="off">
      <input
        :id="acName"
        class="ac-input"
        type="text"
        placeholder="digite seu endereço. ex: nome da rua, número, cidade"
      >
    </form>

    <div class="google-map" :class="{'with-autocomplete': withAutocomplete}" :id="mapName"></div>
  </section>
</template>

<style scoped>
.ac-input {
  width: calc(100% - 30px);
  position: relative;
  padding-left: 10px;
  margin-left: 10px;
  border: 0;
  border-radius: 5px;
  box-shadow: var(--shadow);
  z-index: 2 !important;
}

.google-map {
  width: 100%;
  height: 200px;
  margin: 0 auto;
  background: gray;
  border-radius: 5px;
  z-index: 1 !important;
}

.with-autocomplete {
  margin-top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/GoogleMaps.vue